
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';
import DatePicker from '@/components/DatePicker.vue';
import moment from 'moment-jalaali';
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';
import offlineExporting from 'highcharts/modules/offline-exporting';
import treemap from 'highcharts/modules/treemap';

treemap(Highcharts);
exporting(Highcharts);
offlineExporting(Highcharts);

@Component({ components: { DatePicker, highcharts: Chart } })
export default class Report extends Vue {
  public formTitle = 'گزارشات تجمیعی';
  public data = [];
  public companies = [];
  public groups = [];
  public packageProducts = [];

  public filters = {
    toDate: '',
    fromDate: '',
    phoneNumber: '',
    productId: 0,
    companyId: 0,
    groupId: 0
  };

  public companyChartOptions = {
    chart: {
      type: 'pie',
      style: {
        fontFamily: 'dana'
      }
    },
    title: {
      text: 'چارت موجودی شرکت‌ها'
    },
    plotOptions: {
      pie: {
        showInLegend: true,
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true
        }
      }
    },
    lang: {
      downloadJPEG: 'دانلود JPEG',
      downloadPNG: 'دانلود PNG',
      viewFullscreen: 'نمایش تمام صفحه'
    },
    exporting: {
      buttons: {
        contextButton: {
          menuItems: ['viewFullscreen', 'downloadPNG', 'downloadJPEG']
        }
      }
    },
    tooltip: {
      useHTML: true,
      crosshairs: true,
      formatter: function () {
        return (
          '<b>' + (this as any).point.name + '</b><br /><b>مبلغ: ' + (this as any).y + '</b><br />' + (this as any).percentage.toFixed(1) + ' درصد'
        );
      }
    },
    series: [
      {
        colorByPoint: true,
        data: []
      }
    ],
    colors: ['#009688', '#FFC107', '#9C27B0', '#FF9800', '#8BC34A', '#00BCD4', '#607D8B', '#3F51B5', '#FFEB3B', '#EC407A', '#2196F3', '#795548']
  };
  public groupChartOptions = {
    chart: {
      type: 'pie',
      style: {
        fontFamily: 'dana'
      }
    },
    title: {
      text: 'چارت موجودی گروه‌ها'
    },
    plotOptions: {
      pie: {
        showInLegend: true,
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true
        }
      }
    },
    lang: {
      downloadJPEG: 'دانلود JPEG',
      downloadPNG: 'دانلود PNG',
      viewFullscreen: 'نمایش تمام صفحه'
    },
    exporting: {
      buttons: {
        contextButton: {
          menuItems: ['viewFullscreen', 'downloadPNG', 'downloadJPEG']
        }
      }
    },
    tooltip: {
      useHTML: true,
      crosshairs: true,
      formatter: function () {
        return (
          '<b>' +
          (this as any).point.name +
          '</b><br /><b>مبلغ: ' +
          (this as any).y.toLocaleString() +
          '</b><br />' +
          (this as any).percentage.toFixed(1) +
          ' درصد'
        );
      }
    },
    series: [
      {
        colorByPoint: true,
        data: []
      }
    ],
    colors: ['#009688', '#FFC107', '#9C27B0', '#FF9800', '#8BC34A', '#00BCD4', '#607D8B', '#3F51B5', '#FFEB3B', '#EC407A', '#2196F3', '#795548']
  };

  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'گزارشات',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await Api.getCompanyShortList().then((response: any) => {
      this.companies = response.data;
    });
    await Api.getGroupShortList().then((response: any) => {
      this.groups = response.data;
    });
    await Api.getProducts(2).then((response: any) => {
      this.packageProducts = response.data;
      this.$hideLoading();
    });
    const momentInstance = moment();
    this.filters.toDate = momentInstance.format('jYYYY/jMM/jDD');
    this.filters.fromDate = momentInstance.subtract(7, 'day').format('jYYYY/jMM/jDD');

    await this.initialize();
  }

  async initialize() {
    await this.getData();
  }

  async getData() {
    if (this.filters.companyId == null) this.filters.companyId = 0;
    if (this.filters.groupId == null) this.filters.groupId = 0;

    this.$showLoading();
    await Api.getReportSim(this.filters).then((response: any) => {
      console.log(response.data);
      this.companyChartOptions.series[0].data = response.data.companyData.map((item) => ({
        name: item.name,
        y: item.balance
      }));
      this.groupChartOptions.series[0].data = response.data.groupData.map((item) => ({
        name: item.name,
        y: item.y
      }));

      this.$hideLoading();
    });
  }

  async close() {
    const momentInstance = moment();
    this.filters = {
      toDate: momentInstance.format('jYYYY/jMM/jDD'),
      fromDate: momentInstance.subtract(7, 'day').format('jYYYY/jMM/jDD'),
      phoneNumber: '',
      productId: 0,
      companyId: 0,
      groupId: 0
    };
    this.initialize();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
